import { CHARGE_FEES } from "../constants";
import { DISPLAY_FEE_OPTION, FEE_TYPE } from "../policy-types";
import { RESOLUTION_ID, RESOLUTION_IDS_OF_TYPE_EXCHANGE } from "../../resolutions/constants";
import { PROFILE_CAPABILITIES } from "../../../models/ProfileCapabilities";
import dashboardSettingsStore from "../../../stores/dashboard-settings-store";

export interface IResolutionFeesCapability {
	isRestockingFeeSupported: boolean;
	isReturnFeeSupported: boolean;
	supportedShippingLabelFeeTypes: FEE_TYPE[];
	supportedChargeFeesOptions: CHARGE_FEES[];
	supportedNoFeesDisplayOptions: DISPLAY_FEE_OPTION[];
}

const DEFAULT_FEES_CAPABILITY: IResolutionFeesCapability = {
	isRestockingFeeSupported: true,
	isReturnFeeSupported: true,
	supportedShippingLabelFeeTypes: [
		FEE_TYPE.FREE,
		FEE_TYPE.SHIPMENT_FEE,
		FEE_TYPE.COST,
		FEE_TYPE.COST_PLUS_ITEM_FEE,
		FEE_TYPE.COST_PLUS_SHIPMENT_FEE,
		FEE_TYPE.LABEL_NOT_PROVIDED
	],
	supportedChargeFeesOptions: [
		CHARGE_FEES.DO_NOT_CHARGE_FEE,
		CHARGE_FEES.CHARGE_FEE,
		CHARGE_FEES.WAIVE_FEES
	],
	supportedNoFeesDisplayOptions: [
		DISPLAY_FEE_OPTION.FREE,
		DISPLAY_FEE_OPTION.INCLUDE_ZERO_FREE,
		DISPLAY_FEE_OPTION.DO_NOT_MENTION_FEES
	],
};

/**
 * Resolves fee capability fields based on the policy rule's resolution type.
 * Exchange resolutions use ExchangeResolutionCapability, refund resolutions use RefundResolutionCapability.
 * Cancel order returns defaults (fees not restricted by capabilities for cancel order).
 */
export function resolveFeesCapability(resolutionId: RESOLUTION_ID | undefined): IResolutionFeesCapability {
	if (!resolutionId) {
		return DEFAULT_FEES_CAPABILITY;
	}

	if (resolutionId === RESOLUTION_ID.CANCEL_ORDER) {
		return DEFAULT_FEES_CAPABILITY;
	}

	if (RESOLUTION_IDS_OF_TYPE_EXCHANGE.includes(resolutionId)) {
		return dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.EXCHANGE_RESOLUTION);
	}

	return dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.REFUND_RESOLUTION);
}
